export const ALL_PROPERTY_TYPES = ["HOUSE", "APARTMENT", "GARAGE", "OFFICE", "INDUSTRY", "COMMERCIAL", "OTHER"];
export const ALL_TRANSACTION_TYPES = ["FOR_SALE", "FOR_RENT"];
export const ALL_STATUS_CLASSIFIED = ["DRAFT", "ACTIVE", "INACTIVE"];

/**
 * List of statuses matching MyClassifieds status filter, as in:
 * https://jira.immoweb.be/browse/WEB-6334
 *
 * For example, a PUBLISHABLE classified is considered as a draft.
 */
export const STATUSES_MATCHES: Record<string, string[]> = {
    ACTIVE: ["ACTIVE"],
    INACTIVE: ["INACTIVE", "EXPIRED"],
    DRAFT: ["DRAFT", "PUBLISHABLE"],
};
